import { InvoiceOptions } from '../models/invoice-options';
import { IResult } from '../models/result-models';
import { apiGet, apiPost, apiPut } from './api-utils';

export const getInvoiceOptions = async (): Promise<
    IResult<InvoiceOptions[]>
> => {
    const url = process.env.REACT_APP_API_URL + '/v1/accounts/invoice-options';
    const result = await apiGet<InvoiceOptions[]>(url);
    return result;
};

export const saveInvoiceOptions = async (
    items: InvoiceOptions[]
): Promise<boolean> => {
    const url =
        process.env.REACT_APP_API_URL + '/v1/accounts/warranty-preferences';
    const result = await apiPut<InvoiceOptions[], boolean>(url, items);

    return result.data === true;
};
